jQuery(document).ready(function ($) {

    // Effect accordion / caractéristiques
    $('.charac-tech-mobile h4').on('click', function (e) {
        e.preventDefault();
        if (!$(this).next('.feature-line').hasClass('active')) {
            $('.feature-line').removeClass('active');
            $(this).next('.feature-line').addClass('active');
        } else {
            $(this).next('.feature-line').removeClass('active');
        }
    });

    if($('.slider-attachments') && $('.slider-attachments').length > 0){
        $('.slider-attachments').slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            dots: false,
            // prevArrow: "<span class='previous'></span>",
            // nextArrow: "<span class='next'></span>",
            prevArrow: $('.product-bloc .previous'),
            nextArrow: $('.product-bloc .next'),
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ]
        });
    }

    if($('.slider-markets') && $('.slider-markets').length > 0){
        $('.slider-markets').slick({
            infinite: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            prevArrow: "<span class='previous'></span>",
            nextArrow: "<span class='next'></span>",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    if($('.slider-application') && $('.slider-application').length > 0){
        $('.slider-application').slick({
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            // prevArrow: "<span class='previous'></span>",
            // nextArrow: "<span class='next'></span>",
            prevArrow: $('.bloc-application .previous'),
            nextArrow: $('.bloc-application .next'),
            dots: true,
            arrows:true,
            lazyLoad:false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false
                    }
                }
            ]
        });
    }

    if($('.slider-chart') && $('.slider-chart .slide-chart').length > 0){
        $('.slider-chart').slick({
            infinite: false,
            prevArrow: "<span class='previous'></span>",
            nextArrow: "<span class='next'></span>",
            arrows:true,
            lazyLoad:false
        });
    }

    if($('.slider-product-pictures') && $('.slider-product-pictures').length > 0){
        $('.slider-selected-picture').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-product-pictures',
        });
        $('.slider-product-pictures').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            variableWidth: false,
            adapatativeHeight: false,
            asNavFor: '.slider-selected-picture',
            prevArrow: "<span class='previous'></span>",
            nextArrow: "<span class='next'></span>",
            focusOnSelect: true,
        });
    }

    if($('.product-sheet-navbar ul li') && $('.product-sheet-navbar ul li').length > 0){
        $(document).on('click', '.product-sheet-navbar ul li', function(){
            $('html, body').animate( { scrollTop: ($('#' + $(this).data('scroll')).offset().top - ($('header.header').height() * 2)) }, 900 );
        })
    }


    if($('.price-filter-range') && $('.price-filter-range').length > 0) {
        $('.price-filter-range').each(function () {
            var handlesSlider = document.getElementById($(this).attr('id'));

            var code = $(this).closest('.container-range').attr('id');
            var min_value = $("input[id='min_" + code +"']").attr('min');
            var max_value = $("input[id='max_" + code +"']").attr('max');

            noUiSlider.create(handlesSlider, {
                start: [parseFloat(min_value), parseFloat(max_value)],
                connect: [false, true, false],
                step: 0.05,
                range: {
                    'min': [parseFloat(min_value)],
                    'max': [parseFloat(max_value)]
                }
            });

            var snapValues = [
                document.getElementById('min_' + code),
                document.getElementById('max_' + code)
            ];

            handlesSlider.noUiSlider.on('update', function (values, handle) {
                snapValues[handle].value = values[handle];
            });


            document.getElementById('min_' + code).addEventListener('change', function () {
                handlesSlider.noUiSlider.set([document.getElementById('min_' + code).value, document.getElementById('max_' + code).value]);
            });
            document.getElementById('max_' + code).addEventListener('change', function () {
                handlesSlider.noUiSlider.set([document.getElementById('min_' + code).value, document.getElementById('max_' + code).value]);
            });
        })
    }

    //NAVBAR PRODUCT SHEET
    if($('.product-sheet-navbar') && $('.product-sheet-navbar').length > 0){
        var headersHeight = $('header.header').height();

        var adminNav = 0;
        if($('#toolbar-administration .toolbar-bar') && $('#toolbar-administration .toolbar-bar').length > 0){
            adminNav = $('#toolbar-administration .toolbar-bar').height();
        }

        headersHeight += adminNav;

        var heightToNavbar = $('.container-bg').offset().top - $('.product-sheet-navbar').height() - headersHeight;

        checkScrollForNavbar();

        $(window).on('scroll', function(){
            checkScrollForNavbar();
        })
    }

    function checkScrollForNavbar(){
        var scrollPosition = $(window).scrollTop();
        var midWindowHeight = $(window).scrollTop() + ($(window).height() / 2);

        if(scrollPosition > heightToNavbar){
            $('.product-sheet-navbar').addClass('fixed');
            $('.product-sheet-navbar').removeClass('bottom');
            $('.product-sheet-navbar').css('top', headersHeight + 'px');
        }else if(scrollPosition < heightToNavbar){
            if($('.container-bg:in-viewport').length > 0){
                $('.product-sheet-navbar').removeClass('fixed');
            }else{
                $('.product-sheet-navbar').addClass('fixed');
            }

            $('.product-sheet-navbar').addClass('bottom');
            $('.product-sheet-navbar').css('top', 'unset');
        }

        $('.product-sheet-navbar ul li').removeClass('active');
        $('.product-bloc').each(function(el, i){
            if($(this).offset().top > scrollPosition && $(this).offset().top < midWindowHeight){
                $('.product-sheet-navbar ul li').removeClass('active');
                $("li[data-scroll='" + $(this).attr('id') + "']").addClass('active');
            }else if($(this).offset().top < midWindowHeight && (parseFloat($(this).offset().top) + parseFloat($(this).height())) > midWindowHeight){
                $("li[data-scroll='" + $(this).attr('id') + "']").addClass('active');
            }
        })
    }
    //END NAVBAR PRODUCT SHEET

    var $windowWidth = $(document).width();
    if ($windowWidth < 960) {
        if ($('.category-list') && $('.category-list').length > 0) {
            let count = $('.category-list a').length;

            let initialSlide = 0;
            $('.category-list a').each(function () {
                if($(this).hasClass('active')) {
                    initialSlide = $(this).attr('data-inistialSlide');

                }
            });

            $('.category-list').slick({
                slidesToShow: (count - 1),
                slidesToScroll: 1,
                swipeToSlide: true,
                infinite: true,
                variableWidth: true,
                arrows: false,
                pauseOnFocus: false,
                pauseOnHover: false,
                mobileFirst: true,
                initialSlide: parseInt(initialSlide),
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]

            });
        }
    }
})
